import { getRateTierRulesDefaultItem, rateTierRulesValidationSchema } from './RateTierRuleAPIEndpoints';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { useRef, useEffect, useState } from 'react';
import { TextField } from 'formik-mui';
import { useTranslation } from "react-i18next";
import { Grid } from '@mui/material';
import { UcColorCirclePicker } from 'components/common/UcColorCirclePicker';

export const RateTierRuleForm = (props) => {
    const itemToEdit = props.itemToEdit || getRateTierRulesDefaultItem();
    const existingItems = props.existingItems || [];
    const dialogSubmit = useRef(props.dialogSubmit);
    const formRef = useRef();
    const { t } = useTranslation();
    const [allowZero, setAllowZero] = useState(false);
    const rateChargeType = props.rateChargeType;

    useEffect(() => {
        if (props.dialogSubmit !== dialogSubmit.current) {
            dialogSubmit.current = props.dialogSubmit;
            if (formRef.current) {
                formRef.current.handleSubmit();
            }
        }
        if (itemToEdit.startingUnit <= 0 && itemToEdit.id !== 0) {
            setAllowZero(true);
        }
        else {
            setAllowZero(false);
        }
    }, [props.dialogSubmit, itemToEdit.startingUnit, itemToEdit.id]);
    
    return (
        <div className='ignoreCustomFormStyles'>
            <Formik
                innerRef={formRef}
                initialValues={itemToEdit}
                validationSchema={() => rateTierRulesValidationSchema(allowZero, rateChargeType, t)}  
                onSubmit={(values) => {
                    props.onSubmit(values);
                }}
            > 
                <Form readonly={props.readonly}>
                    <Grid container spacing={2} style={{paddingTop: '8px'}}>
                        <Grid item xs={12} sm={12} md={12}>
                            <Field
                                name={"name"}
                                component={TextField}
                                disabled={props.disabled}
                                label={t("Name")}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <Field
                                name={"description"}
                                component={TextField}
                                disabled={props.disabled}
                                label={t("Description")}                   
                                multiline
                                rows={4}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <Field
                                name={"rate"}
                                component={TextField}
                                disabled={props.disabled}
                                label={t("Rate ($)")}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6}>
                            <Field
                                name={"startingUnit"}
                                component={TextField}
                                disabled={(itemToEdit.startingUnit <= 0 && itemToEdit.id !== 0 ? true : false)}
                                label={t("Starting Unit")}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12}>
                            <Field
                                name={"htmlColor"}
                                existingItems={existingItems}
                                itemToEdit={itemToEdit}
                                value={formRef.current?.values?.htmlColor || itemToEdit.htmlColor}
                                component={UcColorCirclePicker}
                                onChange={(newValue) => {
                                    formRef.current.setFieldValue("htmlColor", newValue);
                                }}
                                label={t("Color")}
                                hint={t('This color will be associated with the rule when rendered on a usage graph.')}
                            />
                        </Grid>
                    </Grid>
                </Form>
            </Formik>
        </div>
    );
}

RateTierRuleForm.defaultProps = {
    id: 0,
    dialogSubmit: 0,
    changeIteration: 0,
    onSubmit: (values) => { console.log("onSubmit not implemented", values); },
    onError: (error) => { console.error("onError not implemented", error); },
};

RateTierRuleForm.propTypes = {
    id: PropTypes.number,
    changeIteration: PropTypes.number,
    dialogSubmit: PropTypes.number,
};